import React, { useEffect, useRef } from 'react';

interface ScrollControllerProps {
  children: React.ReactNode;
}

export function ScrollController({ children }: ScrollControllerProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observerOptions = {
      threshold: [0, 0.1, 0.2, 0.3, 0.5, 0.7, 1],
      rootMargin: '-10% 0px -10% 0px'
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        const el = entry.target as HTMLElement;
        const ratio = entry.intersectionRatio;
        
        if (ratio > 0.1) {
          el.classList.add('in-view');
          el.style.setProperty('--intersection-ratio', ratio.toString());
          // One-shot reveal: stop observing to prevent fade-out flicker
          obs.unobserve(el);
        }
      });
    }, observerOptions);

    // Observe all reveal elements
    const revealElements = containerRef.current?.querySelectorAll('.reveal');
    revealElements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="scroll-controlled">
      {children}
    </div>
  );
}